export interface IArtistSearchTerm {
  type: string[];
  query: string;
  // order_by?: any;
  order_by?: { [key: string]: string };
}
